import React from 'react';
import { useTranslation } from 'react-i18next';
import './Common.css';

/**
 * Loading indicator component
 */
const Loading = ({ text }) => {
  const { t } = useTranslation();
  const displayText = text || t('common.loading');
  return <div className="loading">{displayText}</div>;
};

export default Loading;
